import IAuditoria from "../entities/IAuditoria";
import { IDesviacion } from "../entities/IDesviacion";
import { IDesactivarRegistro } from "../entities/ILogMantenedor";
export const mantenedorDesv: IDesactivarRegistro = {
  AUTOR: "",
  DESACTIVAR: false,
  AUTOR_DISPLAY: "",
  CAMPO: "",
  EDITOR: "",
  EDITOR_DISPLAY: "",
  ID_REGISTRO: 1,
  MODULO: "DESVIACIONES",
  MOTIVO: "",
  TABLA: "DESVIACIONES",
  VALOR_INICIAL: "",
};
export const itemsPlanes = [
  {
    PAGINA: 1,
    PAGINADO: 10,
    ORDENADOPOR: "",
    ORIENTACION: "",
    ID: 1,
    ID_VICEPRESIDENCIA: null,
    ID_GERENCIA_SUBGERENCIA: 123,
    ID_UNIDAD_PROYECTO: 456,
    ID_PROGRAMA_AUDITORIA: 789,
    ID_TIPO_AUDITORIA: 101,
    NOMBRE: "Auditoría 1",
    CORRELATIVO: "AUD-001",
    FECHA_DESDE: new Date("2023-01-15"),
    FECHA_HASTA: new Date("2023-01-20"),
    AUDITOR_LIDER: "Juan Pérez",
    AUDITORES_ACOMPANANTES: "María González, Carlos Rodríguez",
    AUDITOR_EXTERNO: false,
    OBJETIVO_ALCANCE_EXCLUSIONES: "Realizar una auditoría interna",
    ID_ESTADO: 1,
    NOMBRE_AUDITOR_EXTERNO: "",
    ORGANIZACION_AUDITOR_EXTERNO: "",
    AUTOR: "Ana Sánchez",
    FECHA_CREACION: new Date("2023-01-10"),
    EDITOR: "Carlos López",
    FECHA_MODIFICACION: null,
    RESPONSABLE_AREA: "Departamento de Auditoría",
    FECHA_REUNION_INICIAL: "2023-01-16",
    FECHA_REUNION_FINAL: "2023-01-17",
    FECHA_INFORME: "2023-01-25",
    CONCLUSIONES: "Se encontraron algunas no conformidades.",
    RECHAZO: "",
    PLAN_AUDITORIA: "Plan de auditoría",
    ES_HISTORICO: "No",
    RESPONSABLE_AREA_DISPLAY: "Departamento de Auditoría",
    AUDITOR_LIDER_DISPLAY: "Juan Pérez",
    AUDITORES_ACOMPANANTES_DISPLAY: "María González, Carlos Rodríguez",
    AUTOR_DISPLAY: "Ana Sánchez",
    TIPO_AUDITORIA: "Auditoría Interna",
    ESTADO: "En Progreso",
    ESTADO_COLUMNA: "En Progreso",
    PROGRAMA: "Programa de Auditoría",
    VICEPRESIDENCIA: null,
    GERENCIA_SUBGERENCIA: "Gerencia de Operaciones",
    UNIDAD_PROYECTO: "Unidad de Proyecto XYZ",
    ANIO: null,
    REQUISITO_NORMATIVO: "ISO 9001",
    FECHA: "2023-01-15",
    HORA_INICIO: "09:00 AM",
    HORA_FINAL: "12:00 PM",
    ESTADO_PROGRAMA: "Activo",
    FECHA_APROBACION: new Date("2023-01-05"),
    NOMBRE_AUDITOR_EXTERNO_DISPLAY: "",
    EDITOR_DISPLAY: "Carlos López",
    VICEPRESIDENCIA_COLUMNA: "",
    GERENCIA_SUBGERENCIA_COLUMNA: "Gerencia de Operaciones",
    UNIDAD_PROYECTO_COLUMNA: "Unidad de Proyecto XYZ",
    UNIDAD_A_AUDITAR: [1, 2],
    TIPO_ALCANCE: [1, 2],
    TIPO_AUDITORIA_ES_PARTICULAR: false,
    ACTIVO: true,
    ID_ITEM_NORMATIVO: undefined,
  },
];
export const itemsPrograma = [
  {
    ID: 1,
    NOMBRE: "Informe 1",
    ANIO: 2023,
    FECHA_APROBACION: new Date("2023-03-15"),
    CORRELATIVO: "INF-001",
    ID_ESTADO: 1,
    ESTADO: "Aprobado",
    AUTOR: "Juan Pérez",
    AUTOR_DISPLAY: "Juan Pérez",
    FECHA_CREACION: new Date("2023-03-10"),
    EDITOR: "María González",
    EDITOR_DISPLAY: "María González",
    FECHA_MODIFICACION: "2023-03-12",
  },
];

export const auditoriaForm: IAuditoria = {
  ACTIVO: true,
  ANIO: "2023",
  AUDITOR_EXTERNO: true,
  AUDITOR_LIDER: "",
  AUDITOR_LIDER_DISPLAY: "",
  AUDITORES_ACOMPANANTES: "",
  AUDITORES_ACOMPANANTES_DISPLAY: "",
  AUTOR: "",
  AUTOR_DISPLAY: "",
  CONCLUSIONES: "",
  CORRELATIVO: "",
  EDITOR: "",
  EDITOR_DISPLAY: "",
  ES_HISTORICO: "",
  ESTADO: "",
  ESTADO_COLUMNA: "",
  ESTADO_PROGRAMA: "",
  FECHA: "",
  FECHA_APROBACION: new Date(),
  FECHA_CREACION: new Date(),
  FECHA_DESDE: new Date(),
  FECHA_HASTA: new Date(),
  FECHA_INFORME: "",
  FECHA_MODIFICACION: new Date(),
  FECHA_REUNION_FINAL: "",
  FECHA_REUNION_INICIAL: "",
  GERENCIA_SUBGERENCIA: "",
  GERENCIA_SUBGERENCIA_COLUMNA: "",
  HORA_FINAL: "",
  HORA_INICIO: "",
  ID: 1,
  ID_ESTADO: 1,
  ID_GERENCIA_SUBGERENCIA: 1,
  ID_PROGRAMA_AUDITORIA: 1,
  ID_TIPO_AUDITORIA: 1,
  ID_UNIDAD_PROYECTO: 1,
  ID_VICEPRESIDENCIA: 1,
  NOMBRE: "",
  NOMBRE_AUDITOR_EXTERNO: "",
  NOMBRE_AUDITOR_EXTERNO_DISPLAY: "",
  OBJETIVO_ALCANCE_EXCLUSIONES: "",
  ORDENADOPOR: "",
  ORGANIZACION_AUDITOR_EXTERNO: "",
  ORIENTACION: "",
  PAGINA: 1,
  PAGINADO: 1,
  PLAN_AUDITORIA: "",
  PROGRAMA: "",
  RECHAZO: "",
  REQUISITO_NORMATIVO: "",
  RESPONSABLE_AREA: "",
  RESPONSABLE_AREA_DISPLAY: "",
  TIPO_ALCANCE: [],
  TIPO_AUDITORIA: "",
  TIPO_AUDITORIA_ES_PARTICULAR: true,
  UNIDAD_A_AUDITAR: [],
  UNIDAD_PROYECTO: "",
  UNIDAD_PROYECTO_COLUMNA: "",
  VICEPRESIDENCIA: "",
  VICEPRESIDENCIA_COLUMNA: "",
  ID_ITEM_NORMATIVO: 1,
};
export const pond = [{ ID: 1, PONDERACION: 90, NOTA: 4 }];
export const medida = {
  MEDIDA: "dddd",
  NUEVO: true,
  RESPONSABLE: "dddd",
  RESPONSABLE_DISPLAY: "dddd",
  AUTOR: "dddd",
  AUTOR_DISPLAY: "dddd",
  ESTADO_MEDIDA: "dddd",
  FECHA_COMPROMISO: "2023-12-12",
  ID: 2,
  ID_ESTADO: 2,
  OPEN: true,
  DOCUMENTOS: [{ ID: 1, ID_MEDIDA: 1, URL: "test", DESCRIPCION: "test" }],
};
export const planificacion = {
  EVALUADOR_LIDER: "",
  EVALUADOR_LIDER_DISPLAY: "",
  ACTIVO: true,
  ANIO: 2023,
  AREA_RESPONSABLE: "",
  AUTOR: "",
  AUTOR_DISPLAY: "",
  CLASIFICACION: 0,
  CORRELATIVO: "",
  ESTADO_PLANIFICACION: "",
  EVALUADORES: "",
  EVALUADORES_DISPLAY: "",
  FECHA_CREACION: "",
  FECHA_EVALUACION: "",
  ID: 1,
  ID_ESTADO: 0,
  MEDIDAS: [],
  NOMBRE_PROVEEDOR: "",
  NOMBRE_PROVEEDOR_DISPLAY: "",
  OBSERVACIONES: "",
  ORDENADOPOR: "",
  ORIENTACION: "",
  PAGINA: 1,
  PAGINADO: 10,
  PLANIFICACIONES: [],
  PRODUCTO: "",
  PROVEEDOR: "",
  TIPO_PROCESO: "",
  TIPO_PROVEEDOR: "",
  TITULO: "",
};

export const media = (query: any) => {
  return {
    matches: query !== "(min-width: 240px) and (max-width: 767px)",
    media: "",
    onchange: null,
    addListener: jest.fn(),
    removeListener: jest.fn(),
  };
};
export const ev = [
  {
    CALIFICACIONES: [{ ID: 1, TITULO: "c.TITULO", NOTA: 4, PONDERACION: 100 }],
  },
];

export const ec_especial = {
  ID: 1,
  TITULO: "",
  NOMBRE: "string",
  ACTIVO: true,
  ORDEN: 1,
};
export const ec = [
  {
    ID: 1,
    NOMBRE: "string",
    ACTIVO: true,
    ORDEN: 1,
  },
  {
    ID: 2,
    NOMBRE: "string",
    ACTIVO: true,
    ORDEN: 1,
  },
];

export const cbp = [
  {
    ID: 1,
    TITULO: "Objeto 1",
    ACTIVO: true,
  },
  {
    ID: 2,
    TITULO: "Objeto 2",
    ACTIVO: false,
  },
];
export const cbRN = [
  {
    PAGINA: 1,
    PAGINADO: 10,
    ORDENADOPOR: "",
    ORIENTACION: "",
    ID: 1,
    TITULO: "Objeto 1",
    ID_MAESTRO: 101,
    ITEM: "Item 1",
    ACTIVO: true,
    ID_TIPO_AUDITORIA: 1,
    ID_GERENCIA: 201,
    ID_UNIDAD_AUDITAR: 301,
    TIPO_AUDITORIA: "Auditoria Tipo 1",
    GERENCIA: "Gerencia 1",
    UNIDAD_AUDITAR: "Unidad Auditada 1",
    TRANSACTION_ID: 1001,
    FECHA_CREACION: new Date(),
    ES_TIPO_AUDITORIA_PARTICULAR: true,
    TEXTO_DISTINC: null,
  },
  {
    PAGINA: 1,
    PAGINADO: 10,
    ORDENADOPOR: "",
    ORIENTACION: "",
    ID: 2,
    TITULO: "Objeto 2",
    ID_MAESTRO: 102,
    ITEM: "Item 2",
    ACTIVO: false,
    ID_TIPO_AUDITORIA: 2,
    ID_GERENCIA: 202,
    ID_UNIDAD_AUDITAR: 302,
    TIPO_AUDITORIA: "Auditoria Tipo 2",
    GERENCIA: "Gerencia 2",
    UNIDAD_AUDITAR: "Unidad Auditada 2",
    TRANSACTION_ID: 1002,
    FECHA_CREACION: new Date(),
    ES_TIPO_AUDITORIA_PARTICULAR: false,
    TEXTO_DISTINC: null,
  },
];
export const cbContrato = [
  {
    ID: 1,
    TITULO: "Objeto 1",
    ID_CONTRATISTA_SUBCONTRATISTA: 101,
    CODIGO_CONTRATO: "C001",
    CORRELATIVO_PROVEEDOR: "CP001",
    ACTIVO: "Activo",
    TRANSACTION_ID: 1001,
    FECHA_CREACION: new Date(),
    CONTRATISTA_SUBCONTRATISTA: "Contratista 1",
    HIDECOLONEDIT: true,
  },
  {
    ID: 2,
    TITULO: "Objeto 2",
    ID_CONTRATISTA_SUBCONTRATISTA: 102,
    CODIGO_CONTRATO: "C002",
    CORRELATIVO_PROVEEDOR: "CP002",
    ACTIVO: "Inactivo",
    TRANSACTION_ID: 1002,
    FECHA_CREACION: new Date(),
    CONTRATISTA_SUBCONTRATISTA: "Contratista 2",
    HIDECOLONEDIT: false,
  },
];
export const tpd = [
  {
    ID: 1,
    NOMBRE: "Objeto 1",
    ACTIVO: true,
    AUTOR: "Autor 1",
    FECHA_CREACION: new Date(),
    EDITOR: "Editor 1",
    FECHA_MODIFICACION: new Date(),
    TRANSACTION_ID: 1001,
  },
  {
    ID: 2,
    NOMBRE: "Objeto 2",
    ACTIVO: false,
    AUTOR: "Autor 2",
    FECHA_CREACION: new Date(),
    EDITOR: "Editor 2",
    FECHA_MODIFICACION: new Date(),
    TRANSACTION_ID: 1002,
  },
];

export const documentosCausas = [
  {
    PAGINA: 1,
    PAGINADO: 10,
    ORDENADOPOR: "",
    ORIENTACION: "",
    ID: 1,
    ID_TIPO_DOCUMENTO: 2,
    ID_DESVIACION: 3,
    URL: "https://ejemplo.com/documento1.pdf",
    DESCRIPCION: "Documento de ejemplo 1",
    FILE: {},
    ID_AUDITORIA: 4,
    CATEGORIA: "",
  },
  {
    PAGINA: 1,
    PAGINADO: 10,
    ORDENADOPOR: "",
    ORIENTACION: "",
    ID: 2,
    ID_TIPO_DOCUMENTO: 3,
    ID_DESVIACION: 4,
    URL: "https://ejemplo.com/documento2.pdf",
    DESCRIPCION: "Documento de ejemplo 2",
    FILE: {},
    ID_AUDITORIA: 5,
  },
];
export const items: Array<IDesviacion> = [
  {
    ACCION: "",
    ASUNTO: "",
    AUDITORIA: "",
    AUTOR: "",
    AUTOR_DISPLAY: "",
    CONTRATISTA_SUBCONTRATISTA: "",
    CONTRATO: "",
    CORRELATIVO: "",
    DESCRIPCION_INCUMPLIMIENTOS: "",
    DETECTADO_POR: "",
    DETECTADO_POR_DISPLAY: "",
    EDITOR: "",
    EDITOR_DISPLAY: "",
    ESTADO: "",
    FECHA_ASIGNACION: new Date(),
    FECHA_CIERRE: new Date(),
    FECHA_CREACION: new Date(),
    FECHA_DETECCION: new Date(),
    FECHA_ESTIMACION_CIERRE_PLAN_ACCION: new Date(),
    FECHA_HASTA: new Date(),
    FECHA_MODIFICACION: new Date(),
    FECHA_VENCIMIENTO: new Date(),
    GERENCIA_SUBGERENCIA: "",
    ID_AUDITORIA: 0,
    ID_CONTRATISTA_SUBCONTRATISTA: 0,
    ID_CONTRATO: 0,
    ID_ESTADO: 0,
    ID_GERENCIA_SUBGERENCIA: 0,
    ID_POTENCIALIDAD: 0,
    ID_REQUISITO_NORMATIVO: 0,
    ID_TIPO_DESVIACION: 0,
    ID_UNIDAD_PROYECTO: 0,
    ID_VICEPRESIDENCIA: 0,
    OBSERVACION: "",
    ORDENADOPOR: "",
    ORIENTACION: "",
    PAGINA: 0,
    PAGINADO: 1,
    PLAN_ACCION: false,
    POTENCIALIDAD: "",
    REQUISITO_NORMATIVO: "",
    RESPONSABLE: "",
    RESPONSABLE_CIERRE: "",
    RESPONSABLE_CIERRE_DISPLAY: "",
    RESPONSABLE_DISPLAY: "",
    RESPONSABLE_INVESTIGACION: "",
    RESPONSABLE_INVESTIGACION_DISPLAY: "",
    TIPO_CAUSA: "BASICA",
    TIPO_DESVIACION: "",
    UNIDAD_PROYECTO: "",
    VICEPRESIDENCIA: "",
    ACTIVO: false,
    ADECUADAMENTE_EVALUADO: false,
    ADECUADAMENTE_IDENTIFICADO_CONTROL_MATRIZ: false,
    AUDITORES_ACOMPANANTES: "",
    AUDITORES_ACOMPANANTES_DISPLAY: "",
    CAUSA_NIVEL_1: "",
    CAUSA_NIVEL_2: "",
    CAUSA_NIVEL_3: "",
    ESTADO_ACCION: "",
    FECHA_ACCION_REALIZADA: new Date(),
    ID: 1,
    ID_CAUSA: 1,
  },
  {
    ACCION: "",
    ASUNTO: "",
    AUDITORIA: "",
    AUTOR: "",
    AUTOR_DISPLAY: "",
    CONTRATISTA_SUBCONTRATISTA: "",
    CONTRATO: "",
    CORRELATIVO: "",
    DESCRIPCION_INCUMPLIMIENTOS: "",
    DETECTADO_POR: "",
    DETECTADO_POR_DISPLAY: "",
    EDITOR: "",
    EDITOR_DISPLAY: "",
    ESTADO: "",
    FECHA_ASIGNACION: new Date(),
    FECHA_CIERRE: new Date(),
    FECHA_CREACION: new Date(),
    FECHA_DETECCION: new Date(),
    FECHA_ESTIMACION_CIERRE_PLAN_ACCION: new Date(),
    FECHA_HASTA: new Date(),
    FECHA_MODIFICACION: new Date(),
    FECHA_VENCIMIENTO: new Date(),
    GERENCIA_SUBGERENCIA: "",
    ID_AUDITORIA: 0,
    ID_CONTRATISTA_SUBCONTRATISTA: 0,
    ID_CONTRATO: 0,
    ID_ESTADO: 0,
    ID_GERENCIA_SUBGERENCIA: 0,
    ID_POTENCIALIDAD: 0,
    ID_REQUISITO_NORMATIVO: 0,
    ID_TIPO_DESVIACION: 0,
    ID_UNIDAD_PROYECTO: 0,
    ID_VICEPRESIDENCIA: 0,
    OBSERVACION: "",
    ORDENADOPOR: "",
    ORIENTACION: "",
    PAGINA: 0,
    PAGINADO: 1,
    PLAN_ACCION: false,
    POTENCIALIDAD: "",
    REQUISITO_NORMATIVO: "",
    RESPONSABLE: "",
    RESPONSABLE_CIERRE: "",
    RESPONSABLE_CIERRE_DISPLAY: "",
    RESPONSABLE_DISPLAY: "",
    RESPONSABLE_INVESTIGACION: "",
    RESPONSABLE_INVESTIGACION_DISPLAY: "",
    TIPO_CAUSA: "BASICA",
    TIPO_DESVIACION: "",
    UNIDAD_PROYECTO: "",
    VICEPRESIDENCIA: "",
    ACTIVO: false,
    ADECUADAMENTE_EVALUADO: false,
    ADECUADAMENTE_IDENTIFICADO_CONTROL_MATRIZ: false,
    AUDITORES_ACOMPANANTES: "",
    AUDITORES_ACOMPANANTES_DISPLAY: "",
    CAUSA_NIVEL_1: "",
    CAUSA_NIVEL_2: "",
    CAUSA_NIVEL_3: "",
    ESTADO_ACCION: "",
    FECHA_ACCION_REALIZADA: new Date(),
    ID: 2,
    ID_CAUSA: 1,
  },
];

export const causaBasica = {
  ACCION: "",
  AUTOR: "",
  AUTOR_DISPLAY: "",
  CORRELATIVO: "",
  FACTORES_PERSONALES: "",
  CAPACIDADES: "",
  PLAZO: "",
  DESCRIPCION_TECNICA: null,
  EDITOR: "",
  EDITOR_DISPLAY: "",
  ES_EFECTIVO: "",
  ESTADO: "",
  FECHA_ACCION_REALIZADA: new Date(),
  FECHA_ASIGNACION: new Date(),
  FECHA_CREACION: new Date(),
  FECHA_HASTA: new Date(),
  FECHA_INGRESO_ACCION_REALIZADA: new Date(),
  FECHA_MODIFICACION: new Date(),
  ID: 1,
  ID_CAPACIDADES: 1,
  ID_DESVIACION: 1,
  ID_ESTADO: 1,
  ID_FACTORES_PERSONALES: 1,
  ID_TIPO_CAUSA_BASICA: 1,
  MOTIVO_RECHAZO: "",
  NOMBRE: "",
  OBSERVACIONES: "",
  RECHAZO: "",
  RESPONSABLE: "",
  RESPONSABLE_DISPLAY: "",
  TIPO_CAUSA_BASICA: "",
};

export const causaBasica2 = {
  ACCION: "",
  AUTOR: "",
  AUTOR_DISPLAY: "",
  CORRELATIVO: "",
  FACTORES_PERSONALES: "",
  CAPACIDADES: "",
  PLAZO: "",
  DESCRIPCION_TECNICA: "",
  EDITOR: "",
  EDITOR_DISPLAY: "",
  ES_EFECTIVO: "",
  ESTADO: "",
  FECHA_ACCION_REALIZADA: new Date(),
  FECHA_ASIGNACION: new Date(),
  FECHA_CREACION: new Date(),
  FECHA_HASTA: "",
  FECHA_INGRESO_ACCION_REALIZADA: new Date(),
  FECHA_MODIFICACION: new Date(),
  ID: 1,
  ID_CAPACIDADES: 1,
  ID_DESVIACION: 1,
  ID_ESTADO: 1,
  ID_FACTORES_PERSONALES: 1,
  ID_TIPO_CAUSA_BASICA: 1,
  MOTIVO_RECHAZO: "",
  NOMBRE: "",
  OBSERVACIONES: "",
  RECHAZO: "",
  RESPONSABLE: "",
  RESPONSABLE_DISPLAY: "",
  TIPO_CAUSA_BASICA: "",
};
export const causaSistema = {
  ACCION: "",
  ID_REQUISITO_SISTEMA: 1,
  ID_REQUISITOS: 1,
  AUTOR: "",
  AUTOR_DISPLAY: "",
  CORRELATIVO: "",
  FACTORES_PERSONALES: "",
  CAPACIDADES: "",
  PLAZO: "",
  DESCRIPCION_TECNICA: null,
  EDITOR: "",
  EDITOR_DISPLAY: "",
  ES_EFECTIVO: false,
  ESTADO: "",
  FECHA_ACCION_REALIZADA: new Date(),
  FECHA_ASIGNACION: new Date(),
  FECHA_CREACION: new Date(),
  FECHA_HASTA: new Date(),
  FECHA_INGRESO_ACCION_REALIZADA: new Date(),
  FECHA_MODIFICACION: new Date(),
  ID: 1,
  ID_CAPACIDADES: 1,
  ID_DESVIACION: 1,
  ID_ESTADO: 1,
  ID_FACTORES_PERSONALES: 1,
  ID_TIPO_CAUSA_BASICA: 1,
  MOTIVO_RECHAZO: "",
  NOMBRE: "",
  OBSERVACIONES: "",
  RECHAZO: "",
  RESPONSABLE: "",
  RESPONSABLE_DISPLAY: "",
  TIPO_CAUSA_BASICA: "",
};

export const causasBasicas = [
  {
    ACCION: "",
    AUTOR: "",
    AUTOR_DISPLAY: "",
    CORRELATIVO: "",
    FACTORES_PERSONALES: "",
    CAPACIDADES: "",
    PLAZO: "",
    DESCRIPCION_TECNICA: "",
    EDITOR: "",
    EDITOR_DISPLAY: "",
    ES_EFECTIVO: "",
    ESTADO: "",
    FECHA_ACCION_REALIZADA: new Date(),
    FECHA_ASIGNACION: new Date(),
    FECHA_CREACION: new Date(),
    FECHA_HASTA: "",
    FECHA_INGRESO_ACCION_REALIZADA: new Date(),
    FECHA_MODIFICACION: new Date(),
    ID: 1,
    ID_CAPACIDADES: 1,
    ID_DESVIACION: 1,
    ID_ESTADO: 1,
    ID_FACTORES_PERSONALES: 1,
    ID_TIPO_CAUSA_BASICA: 1,
    MOTIVO_RECHAZO: "",
    NOMBRE: "",
    OBSERVACIONES: "",
    RECHAZO: "",
    RESPONSABLE: "",
    RESPONSABLE_DISPLAY: "",
    TIPO_CAUSA_BASICA: "",
  },
];

export const addCausaInmediata = {
  ACCION: "",
  AUTOR: "",
  AUTOR_DISPLAY: "",
  CORRELATIVO: "",
  EDITOR: "",
  EDITOR_DISPLAY: "",
  ES_EFECTIVO: true,
  ESTADO: "",
  FECHA_ACCION_REALIZADA: new Date(),
  FECHA_ASIGNACION: new Date(),
  FECHA_CREACION: new Date(),
  FECHA_HASTA: new Date(),
  FECHA_INGRESO_ACCION_REALIZADA: new Date(),
  FECHA_MODIFICACION: new Date(),
  ID: 1,
  ID_ACTO_CONDICION_SUBESTANDAR: 1,
  ACTO_CONDICION_SUBESTANDAR: "",
  ID_DESVIACION: 1,
  ID_ESTADO: 1,
  ID_TIPO_CAUSA_INMEDIATA: 1,
  TIPO_CAUSA_INMEDIATA: "",
  MOTIVO_RECHAZO: "",
  PLAZO: "2",
  DESCRIPCION: "",
  NOMBRE: "",
  OBSERVACIONES: "",
  RECHAZO: "",
  RESPONSABLE: "",
  RESPONSABLE_DISPLAY: "",
};

export const causasInmediatas = [
  {
    ACCION: "",
    AUTOR: "",
    AUTOR_DISPLAY: "",
    CORRELATIVO: "",
    EDITOR: "",
    EDITOR_DISPLAY: "",
    ES_EFECTIVO: "",
    ESTADO: "",
    FECHA_ACCION_REALIZADA: new Date(),
    FECHA_ASIGNACION: "",
    FECHA_CREACION: new Date(),
    FECHA_HASTA: "",
    FECHA_INGRESO_ACCION_REALIZADA: new Date(),
    FECHA_MODIFICACION: "",
    ID: 1,
    ID_ACTO_CONDICION_SUBESTANDAR: 1,
    ACTO_CONDICION_SUBESTANDAR: "",
    ID_DESVIACION: 1,
    ID_ESTADO: 1,
    ID_TIPO_CAUSA_INMEDIATA: 1,
    TIPO_CAUSA_INMEDIATA: "",
    MOTIVO_RECHAZO: "",
    PLAZO: "2",
    DESCRIPCION: "",
    NOMBRE: "",
    OBSERVACIONES: "",
    RECHAZO: "",
    RESPONSABLE: "",
    RESPONSABLE_DISPLAY: "",
  },
];

export const causasSistemas = [
  {
    ID_TIPO_DOCUMENTO: 1,
    PAGINA: 1,
    PAGINADO: 10,
    ORIENTACION: "",
    ORDENADOPOR: "",
    URL: "",
    ACCION: "",
    AUTOR: "",
    AUTOR_DISPLAY: "",
    CORRELATIVO: "",
    EDITOR: "",
    EDITOR_DISPLAY: "",
    ES_EFECTIVO: "",
    ESTADO: "",
    FECHA_ACCION_REALIZADA: new Date(),
    FECHA_ASIGNACION: "",
    FECHA_CREACION: new Date(),
    FECHA_HASTA: "",
    FECHA_INGRESO_ACCION_REALIZADA: new Date(),
    FECHA_MODIFICACION: "",
    PLAZO: "",
    DESCRIPCION: "",
    ID: 1,
    ID_REQUISITO_SISTEMA: 1,
    ID_DESVIACION: 1,
    ID_ESTADO: 1,
    ID_REQUISITOS: 1,
    REQUISITO_SISTEMA: "",
    REQUISITOS: "",
    MOTIVO_RECHAZO: "",
    NOMBRE: "",
    OBSERVACIONES: "",
    RECHAZO: "",
    RESPONSABLE: "",
    RESPONSABLE_DISPLAY: "",
  },
];

export const causasInmediatas1 = [
  {
    ACCION: "",
    AUTOR: "",
    AUTOR_DISPLAY: "",
    CORRELATIVO: "",
    EDITOR: "",
    EDITOR_DISPLAY: "",
    ES_EFECTIVO: "",
    ESTADO: "",
    FECHA_ACCION_REALIZADA: new Date(),
    FECHA_ASIGNACION: "",
    FECHA_CREACION: new Date(),
    FECHA_HASTA: "",
    FECHA_INGRESO_ACCION_REALIZADA: new Date(),
    FECHA_MODIFICACION: "",
    ID: 1,
    ID_ACTO_CONDICION_SUBESTANDAR: 1,
    ACTO_CONDICION_SUBESTANDAR: "",
    ID_DESVIACION: 1,
    ID_ESTADO: 1,
    ID_TIPO_CAUSA_INMEDIATA: 1,
    TIPO_CAUSA_INMEDIATA: "",
    MOTIVO_RECHAZO: "",
    PLAZO: "2",
    DESCRIPCION: "",
    NOMBRE: "",
    OBSERVACIONES: "",
    RECHAZO: "",
    RESPONSABLE: "",
    RESPONSABLE_DISPLAY: "",
  },
];

export const causasSistemas1 = [
  {
    ID_TIPO_DOCUMENTO: 1,
    PAGINA: 1,
    PAGINADO: 10,
    ORIENTACION: "",
    ORDENADOPOR: "",
    URL: "",
    ACCION: "",
    AUTOR: "",
    AUTOR_DISPLAY: "",
    CORRELATIVO: "",
    EDITOR: "",
    EDITOR_DISPLAY: "",
    ES_EFECTIVO: "",
    ESTADO: "",
    FECHA_ACCION_REALIZADA: new Date(),
    FECHA_ASIGNACION: "",
    FECHA_CREACION: new Date(),
    FECHA_HASTA: "",
    FECHA_INGRESO_ACCION_REALIZADA: new Date(),
    FECHA_MODIFICACION: "",
    PLAZO: "",
    DESCRIPCION: "",
    ID: 1,
    ID_REQUISITO_SISTEMA: 1,
    ID_DESVIACION: 1,
    ID_ESTADO: 1,
    ID_REQUISITOS: 1,
    REQUISITO_SISTEMA: "",
    REQUISITOS: "",
    MOTIVO_RECHAZO: "",
    NOMBRE: "",
    OBSERVACIONES: "",
    RECHAZO: "",
    RESPONSABLE: "",
    RESPONSABLE_DISPLAY: "",
  },
];

export const ar = [
  {
    PAGINA: 1,
    PAGINADO: 10,
    ORDENADOPOR: "",
    ORIENTACION: "",
    ID: 1,
    TITULO: "Primer objeto",
    ACTIVO: true,
  },
  {
    PAGINA: 1,
    PAGINADO: 10,
    ORDENADOPOR: "",
    ORIENTACION: "",
    ID: 2,
    TITULO: "Segundo objeto",
    ACTIVO: false,
  },
];

export const tp = [
  {
    PAGINA: 1,
    PAGINADO: 10,
    ORDENADOPOR: "",
    ORIENTACION: "",
    ID: 1,
    TITULO: "Primer objeto",
    ACTIVO: true,
    ID_AREA_RESPONSABLE: 101,
    AREA_RESPONSABLE: "Área 1",
    FECHA_CREACION: new Date("2023-11-03"),
    TRANSACTION_ID: "ABC123",
  },
  {
    PAGINA: 1,
    PAGINADO: 10,
    ORDENADOPOR: "",
    ORIENTACION: "",
    ID: 2,
    TITULO: "Segundo objeto",
    ACTIVO: false,
    ID_AREA_RESPONSABLE: 102,
    AREA_RESPONSABLE: "Área 2",
    FECHA_CREACION: new Date("2023-11-04"),
    TRANSACTION_ID: "XYZ789",
  },
];

export const arc = [
  {
    ID: 1,
    CAMPO_EDITADO_ID: "campo1",
    CAMPO_EDITADO: "Campo 1",
    VALOR_ORIGINAL: "Valor Original 1",
    VALOR_NUEVO: "Nuevo Valor 1",
    OBJETO_REF: { prop1: "Objeto 1", TIPO: 1 },
    TIPO: 1,
    TABLA_EDITADA: "Tabla 1",
  },
  {
    ID: 2,
    CAMPO_EDITADO_ID: "campo1",
    CAMPO_EDITADO: "Campo 1",
    VALOR_ORIGINAL: "Valor Original 1",
    VALOR_NUEVO: "Nuevo Valor 1",
    OBJETO_REF: { prop1: "Objeto 1", TIPO: 9 },
    TIPO: 9,
    TABLA_EDITADA: "Tabla 1",
  },
  {
    ID: 3,
    CAMPO_EDITADO_ID: "campo1",
    CAMPO_EDITADO: "Campo 1",
    VALOR_ORIGINAL: "Valor Original 1",
    VALOR_NUEVO: "Nuevo Valor 1",
    OBJETO_REF: { prop1: "Objeto 1", TIPO: 3 },
    TIPO: 3,
    TABLA_EDITADA: "Tabla 1",
  },
];

export const vpp = [
  {
    ID: 1,
    TITULO: "Objeto 1",
    ID_MAESTRO: 101,
    USUARIO_RESPONSABLE: "Usuario 1",
    ACTIVO: true,
    TRANSACTION_ID: 10001,
    FECHA_CREACION: new Date("2023-11-01"),
    USUARIO_RESPONSABLE_DISPLAY: "Usuario 1 Display",
  },
  {
    ID: 2,
    TITULO: "Objeto 2",
    ID_MAESTRO: 102,
    USUARIO_RESPONSABLE: "Usuario 2",
    ACTIVO: false,
    TRANSACTION_ID: 10002,
    FECHA_CREACION: new Date("2023-11-02"),
    USUARIO_RESPONSABLE_DISPLAY: "Usuario 2 Display",
  },
];

export const ed = [
  {
    ID: 1,
    NOMBRE: "Objeto 1",
    ACTIVO: true,
    ORDEN: 10,
  },
  {
    ID: 2,
    NOMBRE: "Objeto 2",
    ACTIVO: false,
    ORDEN: 20,
  },
];
export const ta = [
  {
    PAGINA: 1,
    PAGINADO: 10,
    ORDENADOPOR: "",
    ORIENTACION: "",
    ID: 1,
    NOMBRE: "Objeto 1",
    ACTIVO: true,
    ES_GLOBAL: false,
    FECHA_CREACION: new Date(),
    TRANSACTION_ID: "abc123",
  },
  {
    PAGINA: 1,
    PAGINADO: 10,
    ORDENADOPOR: "",
    ORIENTACION: "",
    ID: 2,
    NOMBRE: "Objeto 2",
    ACTIVO: false,
    ES_GLOBAL: true,
    FECHA_CREACION: new Date(),
    TRANSACTION_ID: "xyz789",
  },
];
export const ac = [
  {
    ID: 1,
    CAMPO_EDITADO_ID: "campo1",
    CAMPO_EDITADO: "Campo 1",
    VALOR_ORIGINAL: "Valor Original 1",
    VALOR_NUEVO: "Valor Nuevo 1",
    OBJETO_REF: { ID: 1 },
    TIPO: 3,
    TABLA_EDITADA: "Tabla 1",
  },
  {
    ID: 2,
    CAMPO_EDITADO_ID: "campo2",
    CAMPO_EDITADO: "Campo 2",
    VALOR_ORIGINAL: "Valor Original 2",
    VALOR_NUEVO: "Valor Nuevo 2",
    OBJETO_REF: { ID: 1 },
    TIPO: 9,
    TABLA_EDITADA: "Tabla 2",
  },
  {
    ID: 3,
    CAMPO_EDITADO_ID: "campo2",
    CAMPO_EDITADO: "Campo 2",
    VALOR_ORIGINAL: "Valor Original 2",
    VALOR_NUEVO: "Valor Nuevo 2",
    OBJETO_REF: { ID: 1 },
    TIPO: 1,
    TABLA_EDITADA: "Tabla 2",
  },
];

export const g = [
  {
    PAGINA: 1,
    PAGINADO: 10,
    ORDENADOPOR: "",
    ORIENTACION: "",
    ID: 1,
    TITULO: "Objeto 1",
    ID_MAESTRO_GERENCIA_SUBGERENCIA: "MG001",
    ID_VICEPRESIDENCIA: 1001,
    NOMBRE_VICEPRESIDENCIA: "Vicepresidencia 1",
    VICEPRESIDENCIA: "VP 1",
    USUARIO_RESPONSABLE: "Usuario Responsable 1",
    ES_USUARIO_BACKUP: true,
    USUARIO_BACKUP: "Usuario Backup 1",
    GERENTE_RESPONSABLE: "Gerente Responsable 1",
    GERENTE_BACKUP: "Gerente Backup 1",
    ES_GERENTE_BACKUP: false,
    ACTIVO: true,
    ENCARGADO_ZONAL: "Encargado Zonal 1",
    TRANSACTION_ID: "ABC123-1",
    FECHA_CREACION: new Date(),
    USUARIO_RESPONSABLE_DISPLAY: "Usuario Responsable Display 1",
    USUARIO_BACKUP_DISPLAY: "Usuario Backup Display 1",
    GERENTE_RESPONSABLE_DISPLAY: "Gerente Responsable Display 1",
    GERENTE_BACKUP_DISPLAY: "Gerente Backup Display 1",
    ENCARGADO_ZONAL_DISPLAY: "Encargado Zonal Display 1",
  },
  {
    ID: 2,
    PAGINA: 1,
    PAGINADO: 10,
    ORDENADOPOR: "",
    ORIENTACION: "",
    TITULO: "Objeto 2",
    ID_MAESTRO_GERENCIA_SUBGERENCIA: "MG002",
    ID_VICEPRESIDENCIA: 1002,
    NOMBRE_VICEPRESIDENCIA: "Vicepresidencia 2",
    VICEPRESIDENCIA: "VP 2",
    USUARIO_RESPONSABLE: "Usuario Responsable 2",
    ES_USUARIO_BACKUP: false,
    USUARIO_BACKUP: "Usuario Backup 2",
    GERENTE_RESPONSABLE: "Gerente Responsable 2",
    GERENTE_BACKUP: "Gerente Backup 2",
    ES_GERENTE_BACKUP: true,
    ACTIVO: true,
    ENCARGADO_ZONAL: "Encargado Zonal 2",
    TRANSACTION_ID: "ABC123-2",
    FECHA_CREACION: new Date(),
    USUARIO_RESPONSABLE_DISPLAY: "Usuario Responsable Display 2",
    USUARIO_BACKUP_DISPLAY: "Usuario Backup Display 2",
    GERENTE_RESPONSABLE_DISPLAY: "Gerente Responsable Display 2",
    GERENTE_BACKUP_DISPLAY: "Gerente Backup Display 2",
    ENCARGADO_ZONAL_DISPLAY: "Encargado Zonal Display 2",
  },
];
export const u = [
  {
    PAGINA: 1,
    PAGINADO: 10,
    ORDENADOPOR: "",
    ORIENTACION: "",
    ID: 1,
    TITULO: "Objeto 1",
    NOMBRE_GERENCIA_SUBGERENCIA: "Gerencia/Subgerencia 1",
    ID_GERENCIA_SUBGERENCIA: "GS001",
    NOMBRE_PROYECTO: "Proyecto 1",
    USUARIO_RESPONSABLE: "Usuario Responsable 1",
    USUARIO_RESPONSABLE_DISPLAY: "Usuario Responsable Display 1",
    ES_USUARIO_BACKUP: true,
    USUARIO_BACKUP: "Usuario Backup 1",
    USUARIO_BACKUP_DISPLAY: "Usuario Backup Display 1",
    ACTIVO: true,
    TRANSACTION_ID: "ABC123-1",
    FECHA_CREACION: new Date(),
    CORRELATIVO_ACTUAL: "Correlativo Actual 1",
    CORRELATIVO_SIGUIENTE: "Correlativo Siguiente 1",
    CORRELATIVO_RECLAMOS: "Correlativo Reclamos 1",
  },
  {
    PAGINA: 1,
    PAGINADO: 10,
    ORDENADOPOR: "",
    ORIENTACION: "",
    ID: 2,
    TITULO: "Objeto 2",
    NOMBRE_GERENCIA_SUBGERENCIA: "Gerencia/Subgerencia 2",
    ID_GERENCIA_SUBGERENCIA: "GS002",
    NOMBRE_PROYECTO: "Proyecto 2",
    USUARIO_RESPONSABLE: "Usuario Responsable 2",
    USUARIO_RESPONSABLE_DISPLAY: "Usuario Responsable Display 2",
    ES_USUARIO_BACKUP: false,
    USUARIO_BACKUP: "Usuario Backup 2",
    USUARIO_BACKUP_DISPLAY: "Usuario Backup Display 2",
    ACTIVO: true,
    TRANSACTION_ID: "ABC123-2",
    FECHA_CREACION: new Date(),
    CORRELATIVO_ACTUAL: "Correlativo Actual 2",
    CORRELATIVO_SIGUIENTE: "Correlativo Siguiente 2",
    CORRELATIVO_RECLAMOS: "Correlativo Reclamos 2",
  },
];

export const csc = [
  {
    ID: 1,
    TITULO: "Objeto 1",
    ID_MAESTRO: "MAESTRO001",
    TIPO_CAUSA: "CAUSA1",
    USUARIO_RESPONSABLE: "Usuario Responsable 1",
    USUARIO_RESPONSABLE_DISPLAY: "Usuario Responsable Display 1",
    ES_USUARIO_BACKUP: true,
    USUARIO_BACKUP: "Usuario Backup 1",
    USUARIO_BACKUP_DISPLAY: "Usuario Backup Display 1",
    ACTIVO: true,
    TRANSACTION_ID: 12345,
    FECHA_CREACION: new Date(),
    ID_TIPO_CAUSA: 101,
  },
  {
    ID: 2,
    TITULO: "Objeto 2",
    ID_MAESTRO: "MAESTRO002",
    TIPO_CAUSA: "CAUSA2",
    USUARIO_RESPONSABLE: "Usuario Responsable 2",
    USUARIO_RESPONSABLE_DISPLAY: "Usuario Responsable Display 2",
    ES_USUARIO_BACKUP: false,
    USUARIO_BACKUP: "Usuario Backup 2",
    USUARIO_BACKUP_DISPLAY: "Usuario Backup Display 2",
    ACTIVO: true,
    TRANSACTION_ID: 67890,
    FECHA_CREACION: new Date(),
    ID_TIPO_CAUSA: 102,
  },
];
export const causaInmediata = [
  {
    ID: 1,
    TITULO: "Objeto 1",
    ACTIVO: true,
    AUTOR: "Autor 1",
    FECHA_CREACION: new Date("2023-11-03"),
    EDITOR: "Editor 1",
    FECHA_MODIFICACION: new Date("2023-11-04"),
    TRANSACTION_ID: "abc123",
  },
  {
    ID: 2,
    TITULO: "Objeto 2",
    ACTIVO: false,
    AUTOR: "Autor 2",
    FECHA_CREACION: new Date("2023-11-05"),
    EDITOR: "Editor 2",
    FECHA_MODIFICACION: new Date("2023-11-06"),
    TRANSACTION_ID: "xyz789",
  },
];
export const contrato = [
  {
    ID: "abc123",
    TITULO: "Objeto 1",
    ID_MAESTRO: "Maestro1",
    TIPO_CAUSA: "Causa1",
    USUARIO_RESPONSABLE: "Usuario1",
    USUARIO_RESPONSABLE_DISPLAY: "Usuario Display1",
    ES_USUARIO_BACKUP: true,
    USUARIO_BACKUP: "Usuario Backup1",
    USUARIO_BACKUP_DISPLAY: "Usuario Backup Display1",
    ACTIVO: true,
    TRANSACTION_ID: 12345,
    FECHA_CREACION: new Date("2023-11-03"),
    ID_TIPO_CAUSA: 1,
  },
  {
    ID: "xyz789",
    TITULO: "Objeto 2",
    ID_MAESTRO: "Maestro2",
    TIPO_CAUSA: "Causa2",
    USUARIO_RESPONSABLE: "Usuario2",
    USUARIO_RESPONSABLE_DISPLAY: "Usuario Display2",
    ES_USUARIO_BACKUP: false,
    USUARIO_BACKUP: "Usuario Backup2",
    USUARIO_BACKUP_DISPLAY: "Usuario Backup Display2",
    ACTIVO: false,
    TRANSACTION_ID: 67890,
    FECHA_CREACION: new Date("2023-11-05"),
    ID_TIPO_CAUSA: 2,
  },
];
export const ep = [
  {
    ID: 1,
    TITULO: "Título 1",
    TRANSACTION_ID: "ABC123",
  },
  {
    ID: 2,
    TITULO: "Título 2",
    TRANSACTION_ID: "XYZ456",
  },
];
export const aspectos = [
  {
    TRANSACTION_ID: "TX001",
    NOMBRE_TIPO_ASPECTO: "NombreTipoAspectoEjemplo",
    ID_TIPO_ASPECTO: 123,
    ACTIVO: true,
    ID: 1,
    ACCION_REALIZADA: "AccionRealizadaEjemplo",
    ACCION_REALIZADA_POR: "A.R.P.",
    FECHA_HASTA: new Date("2023-08-01"),
    FECHA_ASIGNACION: new Date("2023-09-01"),
    FECHA_INGRESO_ACCION_REALIZADA: new Date("2023-10-01"),
    ID_ASPECTO: 124,
    ID_TIPO_EVALUACION: 125,
    ID_INSPECCION_OBSERVACION: 126,
    RESPONSABLE: "ResponsableEjemplo",
    RESPONSABLE_DISPLAY: "R.D.",
    TITULO_ASPECTO: "TituloAspectoEjemplo",
    AUTOR: "AutorEjemplo",
    AUTOR_DISPLAY: "A.D.",
    EDITOR: "EditorEjemplo",
    EDITOR_DISPLAY: "E.D.",
    FECHA_CREACION: new Date("2023-11-01"),
    FECHA_MODIFICACION: new Date("2023-12-01"),
    TITULO: "TituloEjemplo",
    NOMBRE_ELEMENTO: "NombreElementoEjemplo",
    ID_ESTADO: 127,
    ESTADO: "EstadoEjemplo",
    ES_TITULO: true,
    ID_NODO_ASPECTO: "IDNA123",
    ASPECTO_EVALUADO: "AspectoEvaluadoEjemplo",
    FECHA_ACCIONAR: new Date("2024-01-01"),
    OBSERVACION: "ObservacionEjemplo",
    MOTIVO_RECHAZO: "MotivoRechazoEjemplo",
    COMENTARIOS: "ComentariosEjemplo",
  },
];
export const itemsLIO = [
  {
    NOMBRE_ELEMENTO: "NombreElementoEjemplo",
    NUMERO_ASPECTO: "NA123",
    NUMER_TRABAJO_REALIZADO: 456,
    ENCARGADO_ZONAL_DISPLAY: "E. Zonal",
    ID: 1,
    TITULO: "TítuloEjemplo",
    ID_VICEPRESIDENCIA: 2,
    ID_GERENCIA_SUBGERENCIA: 3,
    ID_UNIDAD_PROYECTO: 4,
    ID_CONTRATISTA_SUBCONTRATISTA: 5,
    FECHA_DETECCION: new Date("2023-01-01"),
    OBSERVACIONES: "Observaciones ejemplo",
    CORRELATIVO: "C001",
    INSTALACION_INTERVENIR: "InstalaciónEjemplo",
    FECHA: new Date("2023-02-01"),
    JEFE_FAENA_SUPERVISOR: "J. Supervisor",
    JEFE_FAENA_SUPERVISOR_DISPLAY: "J.S.",
    HORARIO: "9:00AM - 5:00PM",
    INSPECTOR_FAENA: "I. Faena",
    INSPECTOR_FAENA_DISPLAY: "I.F.",
    ATN: "ATNEjemplo",
    USUARIO_CONTRATISTA: "U. Contratista",
    USUARIO_ENCARGADO_ZO: "U.E.Z.",
    ID_TIPO_LISTA: 6,
    ID_TIPO_FAENA: 7,
    ID_ESTADO: 8,
    ID_TIPO_INTERNO_EXTERNO: 9,
    ES_CERRAR_CON: true,
    CERRAR_CON_OBSERVACION: "Observación cierre",
    FECHA_CIERRE: new Date("2023-03-01"),
    CERRADO_POR: "C.P.",
    CERRADO_POR_DISPLAY: "C.P.D.",
    TIENE_RECHAZO_ENCARGADO: true,
    RECHAZO_ENCARGADO_ZO: "Rechazo Z.O.",
    AUTOR: "AutorEjemplo",
    FECHA_CREACION: new Date("2023-04-01"),
    EDITOR: "EditorEjemplo",
    FECHA_MODIFICACION: new Date("2023-05-01"),
    TRANSACTION_ID: "T001",
    ESTADO_INSPECCION_OBSERVACION: "EstadoEjemplo",
    VICEPRESIDENCIA: "VicepresidenciaEjemplo",
    GERENCIA_SUBGERENCIA: "GerenciaEjemplo",
    UNIDAD_PROYECTO: "UnidadProyectoEjemplo",
    CONTRATISTA_SUBCONTRATISTA: "ContratistaEjemplo",
    USUARIO_ENCARGADO_ZO_DISPLAY: "U.E.Z.D.",
    AUTOR_DISPLAY: "A.D.",
    EDITOR_DISPLAY: "E.D.",
    USUARIO_CONTRATISTA_DISPLAY: "U.C.D.",
    FAENA: "FaenaEjemplo",
    ASPECTO: "AspectoEjemplo",
    FECHA_INGRESO: "2023-06-01",
    RESPONSABLE: "ResponsableEjemplo",
    RESPONSABLE_DISPLAY: "R.D.",
    FECHA_HASTA: "2023-07-01",
    ENCARGADO_ZONAL: "EncargadoZonalEjemplo",
    TIPO_LISTA: "TipoListaEjemplo",
    ESTADO: "EstadoEjemplo",
    TIPO_FAENA: "TipoFaenaEjemplo",
    ID_FAENA: "IDFEjemplo",
    ASPECTOS_EVALUAR: null,
    OBSERVACION: true,
    ACTIVO: true,
    NUEVO_FORMATO_FAENA: false,
  },
];
export const itemsRLIO = [
  {
    PAGINA: 1,
    PAGINADO: 10,
    ORDENADOPOR: "ID",
    ORIENTACION: "DESC",
    ID: 301,
    NUMERO_INSPECCION: "INS-001",
    VICEPRESIDENCIA: "Vicepresidencia de Operaciones",
    VICEPRESIDENCIA_COLUMNA: "Operaciones",
    GERENCIA_SUBGERENCIA: "Gerencia de Tecnología",
    GERENCIA_SUBGERENCIA_COLUMNA: "Tecnología",
    UNIDAD_PROYECTO: "Desarrollo Web",
    UNIDAD_PROYECTO_COLUMNA: "Web",
    CONTRATISTA_SUBCONTRATISTA: "Contratista XYZ",
    CONTRATISTA_SUBCONTRATISTA_COLUMNA: "XYZ",
    FECHA_DESDE: "2023-01-01",
    FECHA_HASTA: "2023-01-31",
    FECHA_DETECCION: new Date("2023-01-10"),
    OBSERVACION: "Todo en orden.",
    CORRELATIVO: "COR-001",
    INSTALACION_INTERVENIR: "Instalación 1",
    JEFE_FAENA: "Roberto Gómez",
    INSPECCIONADO_POR: "Carlos Pérez",
    TIPO_FAENA: "Tipo 1",
    FAENA: "Faena Principal",
    ATN: "ATN-001",
    ENCARGADO_ZONAL: "Eduardo Díaz",
    DETECTADO_POR: "Sensor 1",
    TIPO_LISTA: "Lista A",
    ESTADO: "Finalizado",
    FECHA_CIERRE: new Date("2023-01-20"),
    CERRADO_POR: "María Rodríguez",
    FECHA_CREACION: new Date("2023-01-05"),
  },
];
export const itemsRLIONuevoFormato = [
  {
    PAGINA: 1,
    PAGINADO: 10,
    ORDENADOPOR: "ID",
    ORIENTACION: "DESC",
    ID: 301,
    NUMERO_INSPECCION: "INS-001",
    VICEPRESIDENCIA: "Vicepresidencia de Operaciones",
    VICEPRESIDENCIA_COLUMNA: "Operaciones",
    GERENCIA_SUBGERENCIA: "Gerencia de Tecnología",
    GERENCIA_SUBGERENCIA_COLUMNA: "Tecnología",
    UNIDAD_PROYECTO: "Desarrollo Web",
    UNIDAD_PROYECTO_COLUMNA: "Web",
    FECHA_DESDE: "2023-01-01",
    FECHA_HASTA: "2023-01-31",
    FECHA_DETECCION: new Date("2023-01-10"),
    OBSERVACION: "Todo en orden.",
    CORRELATIVO: "COR-001",
    INSTALACION_INTERVENIR: "Instalación 1",
    INSPECCIONADO_POR: "Carlos Pérez",
    TIPO_FAENA: "Tipo 1",
    FAENA: "Faena Principal",
    ATN: "ATN-001",
    DETECTADO_POR: "Sensor 1",
    TIPO_LISTA: "Lista A",
    ESTADO: "Finalizado",
    FECHA_CIERRE: new Date("2023-01-20"),
    CERRADO_POR: "María Rodríguez",
    FECHA_CREACION: new Date("2023-01-05"),
  },
];
export const pr = [
  {
    PAGINA: 1,
    PAGINADO: 10,
    ORDENADOPOR: "",
    ORIENTACION: "",
    ID: 1,
    TITULO: "Objeto 1",
    ACTIVO: true,
    ID_TIPO_PROCESO: 101,
    TIPO_PROCESO: "Proceso 1",
    FECHA_CREACION: new Date("2023-11-03"),
    TRANSACTION_ID: "1001",
    PARAMETROS_EVALUAR: [1, 2, 3],
  },
  {
    PAGINA: 1,
    PAGINADO: 10,
    ORDENADOPOR: "",
    ORIENTACION: "",
    ID: 2,
    TITULO: "Objeto 2",
    ACTIVO: false,
    ID_TIPO_PROCESO: 102,
    TIPO_PROCESO: "Proceso 2",
    FECHA_CREACION: new Date("2023-11-04"),
    TRANSACTION_ID: "1002",
    PARAMETROS_EVALUAR: [4, 5, 6],
  },
];

export const pv = [
  {
    PAGINA: 1,
    PAGINADO: 10,
    ORDENADOPOR: "",
    ORIENTACION: "",
    ID: 1,
    TITULO: "Objeto 1",
    PROVEEDOR: "Proveedor A",
    ACTIVO: true,
    ID_TIPO_PROVEEDOR: 101,
    TIPO_PROVEEDOR: "Tipo 1",
    ID_PRODUCTO: 201,
    PRODUCTO: "Producto A",
    TIPO_PROCESO: "Proceso 1",
    AREA_RESPONSABLE: "Área 1",
    USUARIOS: "Usuario 1",
    USUARIOS_DISPLAY: "Usuario Display 1",
    PROVEEDOR_EXTERNO: "Proveedor Externo 1",
    PROVEEDOR_EXTERNO_DISPLAY: "Proveedor Externo Display 1",
    FECHA_CREACION: new Date("2023-11-03"),
    TRANSACTION_ID: "1001",
  },
  {
    PAGINA: 1,
    PAGINADO: 10,
    ORDENADOPOR: "",
    ORIENTACION: "",
    ID: 2,
    TITULO: "Objeto 2",
    PROVEEDOR: "Proveedor B",
    ACTIVO: false,
    ID_TIPO_PROVEEDOR: 102,
    TIPO_PROVEEDOR: "Tipo 2",
    ID_PRODUCTO: 202,
    PRODUCTO: "Producto B",
    TIPO_PROCESO: "Proceso 2",
    AREA_RESPONSABLE: "Área 2",
    USUARIOS: "Usuario 2",
    USUARIOS_DISPLAY: "Usuario Display 2",
    PROVEEDOR_EXTERNO: "Proveedor Externo 2",
    PROVEEDOR_EXTERNO_DISPLAY: "Proveedor Externo Display 2",
    FECHA_CREACION: new Date("2023-11-04"),
    TRANSACTION_ID: "1002",
  },
];

export const itemsP = [
  {
    PAGINA: 1,
    PAGINADO: 10,
    ORDENADOPOR: "",
    ORIENTACION: "",
    ID: 1,
    CORRELATIVO: "COR001",
    CLASIFICACION: 2,
    OBSERVACIONES: "Observaciones 1",
    TITULO: "Título 1",
    ANIO: 2023,
    AREA_RESPONSABLE: "Área 1",
    TIPO_PROCESO: "Tipo de Proceso 1",
    PRODUCTO: "Producto 1",
    TIPO_PROVEEDOR: "Tipo de Proveedor 1",
    FECHA_CREACION: "2023-11-03",
    PROVEEDOR: "Proveedor 1",
    NOMBRE_PROVEEDOR: "Nombre Proveedor 1",
    NOMBRE_PROVEEDOR_DISPLAY: "Nombre Display 1",
    FECHA_EVALUACION: "2023-11-04",
    EVALUADOR_LIDER: "Evaluador Líder 1",
    EVALUADOR_LIDER_DISPLAY: "Evaluador Líder Display 1",
    EVALUADORES: "Evaluadores 1",
    EVALUADORES_DISPLAY: "Evaluadores Display 1",
    AUTOR: "Autor 1",
    AUTOR_DISPLAY: "Autor Display 1",
    ESTADO_PLANIFICACION: "Estado Planificación 1",
    MEDIDAS: [
      { medida: "Medida 1", detalle: "Detalle Medida 1" },
      { medida: "Medida 2", detalle: "Detalle Medida 2" },
    ],
    ID_PLAN: 1001,
    PROVEEDOR_RESPONSABLE: "Proveedor Responsable 1",
    ID_ESTADO: 3,
    ID_PROVEEDOR: 2001,
    ID_TIPO_PROVEEDOR: 1,
    ID_PRODUCTO: 3001,
    ID_EVALUACION: 4001,
    USUARIO_PROVEEDOR: "Usuario Proveedor 1",
    PLANIFICACIONES: [],
    ACTIVO: true,
  },
];
export const auditoria = [
  {
    PAGINA: 1,
    PAGINADO: 10,
    ORDENADOPOR: "",
    ORIENTACION: "",
    ID: 1,
    NOMBRE: "Objeto 1",
    ACTIVO: true,
    ES_GLOBAL: false,
    FECHA_CREACION: new Date("2023-01-15"),
    TRANSACTION_ID: "ABC123",
  },
  {
    PAGINA: 1,
    PAGINADO: 10,
    ORDENADOPOR: "",
    ORIENTACION: "",
    ID: 2,
    NOMBRE: "Objeto 2",
    ACTIVO: false,
    ES_GLOBAL: true,
    FECHA_CREACION: new Date("2023-02-20"),
    TRANSACTION_ID: "XYZ789",
  },
];

export const itemsPR = [
  {
    ID: 1,
    CORRELATIVO: "string",
    CLASIFICACION: 1,
    OBSERVACIONES: "string",
    TITULO: "string",
    ANIO: 1,
    AREA_RESPONSABLE: "string",
    TIPO_PROCESO: "string",
    PRODUCTO: "string",
    TIPO_PROVEEDOR: "string",
    FECHA_CREACION: "string",
    PROVEEDOR: "string",
    NOMBRE_PROVEEDOR: "string",
    NOMBRE_PROVEEDOR_DISPLAY: "string",
    FECHA_EVALUACION: "string",
    EVALUADOR_LIDER: "string",
    EVALUADOR_LIDER_DISPLAY: "string",
    EVALUADORES: "string",
    EVALUADORES_DISPLAY: "string",
    AUTOR: "string",
    AUTOR_DISPLAY: "string",
    ESTADO_PLANIFICACION: "string",
    MEDIDAS: [],
    ID_PLAN: 1,
    PROVEEDOR_RESPONSABLE: "string",
    ID_ESTADO: 1,
    ID_PROVEEDOR: 1,
    ID_TIPO_PROVEEDOR: 1,
    ID_PRODUCTO: 1,
    ID_EVALUACION: 1,
    USUARIO_PROVEEDOR: "string",
  },
];

export const desactivarRegistro: IDesactivarRegistro = {
  DESACTIVAR: true,
  MODULO: "AUDITORIA",
  TABLA: "AUDITORIA",
  ID_REGISTRO: 1,
  CAMPO: "",
  VALOR_INICIAL: "",
  MOTIVO: "",
  AUTOR: "",
  EDITOR: "",
  AUTOR_DISPLAY: "",
  EDITOR_DISPLAY: "",
};

export const cbPR = [
  {
    PAGINA: 1,
    PAGINADO: 10,
    ORDENADOPOR: "ID",
    ORIENTACION: "DESC",
    TITULO: "Objeto 1",
    PROVEEDOR: "Proveedor 1",
    ACTIVO: true,
    ID_TIPO_PROVEEDOR: 1,
    TIPO_PROVEEDOR: "Tipo 1",
    ID_PRODUCTO: 101,
    PRODUCTO: "Producto 1",
    TIPO_PROCESO: "Proceso 1",
    AREA_RESPONSABLE: "Área 1",
    USUARIOS: "Usuario 1",
    USUARIOS_DISPLAY: "Usuario Uno",
    PROVEEDOR_EXTERNO: "Proveedor Externo 1",
    PROVEEDOR_EXTERNO_DISPLAY: "Proveedor Externo Uno",
    FECHA_CREACION: new Date(),
    TRANSACTION_ID: "ABC123",
  },
  {
    PAGINA: 1,
    PAGINADO: 10,
    ORDENADOPOR: "ID",
    ORIENTACION: "DESC",
    TITULO: "Objeto 2",
    PROVEEDOR: "Proveedor 2",
    ACTIVO: false,
    ID_TIPO_PROVEEDOR: 2,
    TIPO_PROVEEDOR: "Tipo 2",
    ID_PRODUCTO: 102,
    PRODUCTO: "Producto 2",
    TIPO_PROCESO: "Proceso 2",
    AREA_RESPONSABLE: "Área 2",
    USUARIOS: null,
    USUARIOS_DISPLAY: null,
    PROVEEDOR_EXTERNO: null,
    PROVEEDOR_EXTERNO_DISPLAY: null,
    FECHA_CREACION: new Date(),
    TRANSACTION_ID: "XYZ789",
  },
];

export const cbPs = [
  {
    PAGINA: 1,
    PAGINADO: 10,
    ORDENADOPOR: "ID",
    ORIENTACION: "DESC",
    TITULO: "Objeto 1",
    ACTIVO: true,
    ID_TIPO_PROCESO: 1,
    TIPO_PROCESO: "Proceso A",
    FECHA_CREACION: new Date(),
    TRANSACTION_ID: "ABC123",
    PARAMETROS_EVALUAR: [1, 2, 3],
  },
  {
    PAGINA: 1,
    PAGINADO: 10,
    ORDENADOPOR: "ID",
    ORIENTACION: "DESC",
    TITULO: "Objeto 2",
    ACTIVO: false,
    ID_TIPO_PROCESO: 2,
    TIPO_PROCESO: "Proceso B",
    FECHA_CREACION: new Date(),
    TRANSACTION_ID: "XYZ789",
    PARAMETROS_EVALUAR: [4, 5, 6],
  },
];

export const plan = {
  ID: 1,
  TITULO: "string",
  ANIO: "2023",
  RESPONSABLE: "string",
  ID_AREA_RESPONSABLE: "string",
  ID_TIPO_PROCESO: "string",
  ID_PROVEEDOR: 0,
  ID_PRODUCTO: 0,
  EVALUADOR_LIDER: "",
  FECHA_EVALUACION: "",
  ID_ESTADO: 1,
  AUTOR: "string",
  TRANSACTION_ID: "string",
  AREA_RESPONSABLE: "string",
  TIPO_PROCESO: "string",
  RESPONSABLE_DISPLAY: "string",
  AUTOR_DISPLAY: "string",
  ACTIVO: true,
};
